import * as Sentry from "@sentry/react";

const sentryDsn =
  document.querySelector('meta[name="sentry-dsn"]')?.getAttribute("content") ||
  "https://909d04062815b8f187aa2804e302d991@bugs.montedelgallo.com/api/v1/sentry_errors/13";

export function initializeSentry() {
  if (!sentryDsn || window.__ugcSentryInitialized) return;

  Sentry.init({
    dsn: sentryDsn,
    environment: document.documentElement.dataset.environment || "development",
    integrations: [],
    tracesSampleRate: 0.1
  });

  window.__ugcSentryInitialized = true;
}
